import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";

import SlhCoreDropdownItemSeparator from "@slhuicore/dropdown-item-separator";
import { style } from "./assets/dropdown-item-separator.generated-style";

/**
 * Allow users to add separator in dropdown
 *
 * @CustomElement slh-dropdown-item-separator
 *
 * @cssprop --slh-default-font-family - Dropdown item separator font family.
 * @cssprop --slh-base-xs-font-size -Dropdown item separator font size.
 * @cssprop --slh-base-bold-font-weight - Dropdown item separator font weight.
 * @cssprop --slh-base-xxs-line-height - Dropdown item separator font line height.
 * @cssprop --slh-color-neutral-shade-00 - Dropdown item separator background.
 * @cssprop --slh-color-neutral-shade-20 - Border color.
 * @cssprop --slh-color-neutral-shade-80 - Font color.
 *
 * ** slots
 * @slot default - Plain text
 */
@customElement("slh-dropdown-item-separator")
export default class SlhDropdownItemSeparator extends SlhCoreDropdownItemSeparator(
  LitElement
) {
  static styles = style;
}
